export enum SecurityLevel {
	Public,
	Client,
	PublicClient,
	Outsider,
	Resource,
	ClientOrOutsider,
	ResourceOrClientOrOutsider,
	ResourceOrClient,
	ResourceOrOutsider,
	Developer,
}
